<template>
  <!-- 常规商品仓库 - 直接装箱弹窗 -->
  <div>
    <!-- 直接装箱主弹窗：预览勾选库存、填写装箱数量与箱规 -->
    <el-dialog title="直接装箱" :visible.sync="dialogVisible" width="1300px" class="direct-packing-dialog"
      :close-on-click-modal="false">
      <!-- 待装箱商品明细 -->
      <el-table :data="list" border v-loading="loading" :header-cell-style="{ background: '#EDEFF4', }">
        <!-- 序号 -->
        <el-table-column align="center" label="NO" width="50">
          <template slot-scope="scope">{{ scope.$index + 1 }}</template>
        </el-table-column>
        <!-- 库位：区域编号 + 库位号 -->
        <el-table-column align="center" label="库位" width="150">
          <template slot-scope="scope">
            <p>{{ getGridNumber(scope.row).split(' ')[0] }}</p>
            <p class="red">{{ getGridNumber(scope.row).split(' ')[1] }}</p>
          </template>
        </el-table-column>
        <!-- 订单编号 + 客户姓名 -->
        <el-table-column align="center" label="订单编号" width="170">
          <template slot-scope="scope">
            <router-link :to="'/orderPaymentDetail?order_sn=' + getOrderSn(scope.row)" target="_blank" class="a-link">
              {{ getOrderSn(scope.row) }}
            </router-link>
            <p>{{ getUserName(scope.row) }}</p>
          </template>
        </el-table-column>
        <!-- 番号 -->
        <el-table-column align="center" label="番号" width="55">
          <template slot-scope="scope">{{ getSorting(scope.row) }}</template>
        </el-table-column>
        <!-- 商品图片 -->
        <el-table-column align="center" label="图片" width="80">
          <template slot-scope="scope">
            <el-popover placement="right" width="300" trigger="hover" v-if="getPic(scope.row)">
              <img :src="getPic(scope.row)" alt="" style="width: 300px; height: 300px" />
              <img :src="getPic(scope.row)" alt="" slot="reference" style="width: 50px; height: 50px" />
            </el-popover>
          </template>
        </el-table-column>
        <!-- 商品属性 detail_y -->
        <el-table-column align="center" label="商品属性" min-width="130">
          <template slot-scope="scope">
            <div v-for="(item, index) in getDetail(scope.row)" :key="index">
              {{ item.key }}：{{ item.value }}
            </div>
          </template>
        </el-table-column>
        <!-- 交易号 purchase_no + 物流号 express_no 列表 -->
        <el-table-column align="center" label="交易号/物流号" min-width="190">
          <template slot-scope="scope">
            <p>JY：{{ getPurchaseNo(scope.row) }}</p>
            <p v-for="(item, index) in getExpressList(scope.row)" :key="index">
              WL{{ index + 1 }}：{{ item.express_no }}
            </p>
          </template>
        </el-table-column>
        <!-- 可移库数 can_move_num / num -->
        <el-table-column align="center" label="可移库数" width="90">
          <template slot-scope="scope">{{ getCanMoveNum(scope.row) }}</template>
        </el-table-column>
        <!-- 直接装箱数量 pack_num -->
        <el-table-column align="center" label="直接装箱数量" width="130">
          <template slot-scope="scope">
            <el-input v-model="scope.row.pack_num" @input="limitNum(scope.row)" />
          </template>
        </el-table-column>
      </el-table>
      <!-- 箱规信息：箱型、长宽高、重量 -->
      <div class="direct-packing-form">
        <el-form :inline="true" :model="datas" label-position="top">
          <!-- 箱型 attr，切换后联动 c/k/g -->
          <el-form-item label="箱型">
            <el-select v-model="datas.attr" placeholder="箱型" @change="changeAttr">
              <el-option v-for="item in attrOption" :key="item.value" :label="item.label"
                :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <!-- 长 c -->
          <el-form-item label="长.cm">
            <el-input v-model="datas.c"></el-input>
          </el-form-item>
          <!-- 宽 k -->
          <el-form-item label="宽.cm">
            <el-input v-model="datas.k"></el-input>
          </el-form-item>
          <!-- 高 g -->
          <el-form-item label="高.cm">
            <el-input v-model="datas.g"></el-input>
          </el-form-item>
          <!-- 重量 weight -->
          <el-form-item label="重量.kg">
            <el-input v-model="datas.weight"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <!-- 底部操作：取消 / 确认后进入库位选择 -->
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" :loading="submitLoading" @click="submit">确认</el-button>
      </span>

    </el-dialog>
    <!-- 普通仓库库位选择：type=12，选位后回调 submitPacking -->
    <warehouse v-if="warehouseDialogVisible" :shelf_type_set="normalWarehouseShelfTypes" :type="12" />
  </div>
</template>

<script>
import { attrOption } from '@/utlis/options'
import warehouse from '@/components/common/warehouse'

// 常规商品仓库 - 直接装箱弹窗组件
// 流程：父页面 init(勾选库存) -> preview 预览 -> 填写 pack_num/箱规 -> submit 打开库位 -> submitPacking 提交 packFromStock
export default {
  components: {
    warehouse,
  },
  data() {
    return {
      dialogVisible: false, // 直接装箱弹窗显示状态
      loading: false, // 预览列表 loading
      submitLoading: false, // 提交装箱 loading
      warehouseDialogVisible: false, // 普通仓库库位弹窗显示状态
      // 直接装箱只能选择普通仓库库位，库位号由仓库组件回填到 datas.grid_number
      normalWarehouseShelfTypes: [1],
      // 箱型选项统一取公共配置，避免页面写死后和系统配置不一致
      attrOption,
      // 父页面勾选的库存行副本，弹窗内修改不直接污染父页面
      selectList: [],
      // 预览接口返回后用于表格展示和提交的明细
      list: [],
      // 箱规、重量、目标库位等整箱信息
      datas: this.getDefaultDatas(),
    }
  },
  methods: {
    /*
     * 字段读取说明（兼容预览接口与库存原始行）：
     * stock_id/id、grid_number、order_sn、sorting、pic、detail_y
     * purchase_no、order_purchase_express、can_move_num/num、pack_num
     * 提交参数：list[{stock_id,num}]、attr、c、k、g、weight、grid_number
     */
    // 打开弹窗：复制勾选库存并请求直接装箱预览
    init(selectList) {
      this.resetDialogData()
      this.selectList = JSON.parse(JSON.stringify(selectList || []))
      this.dialogVisible = true
      this.preview()
    },
    // 每次打开弹框都重置内部状态，避免沿用上一次的数量、箱规、库位或 loading
    resetDialogData() {
      this.loading = false
      this.submitLoading = false
      this.warehouseDialogVisible = false
      this.selectList = []
      this.list = []
      this.datas = this.getDefaultDatas()
    },
    // 默认箱规信息
    getDefaultDatas() {
      const attr = attrOption.length ? attrOption[0].value : ''
      const size = this.getAttrSize(attr)
      return {
        attr, // 箱型
        c: size[0], // 长 cm
        k: size[1], // 宽 cm
        g: size[2], // 高 cm
        weight: '', // 重量 kg
        grid_number: '', // 目标库位号，由仓库组件回填
      }
    },
    // 解析箱型中的长宽高，attrOption 维护后默认值也会同步变化
    getAttrSize(value) {
      const size = String(value || '').split('*')
      return [Number(size[0] || 0), Number(size[1] || 0), Number(size[2] || 0)]
    },
    // 生成预览明细，并为每一行补充可移库数和默认装箱数
    preview() {
      this.loading = true
      const list = this.selectList.map(item => ({
        stock_id: item.id,
        num: this.getCanMoveNum(item),
      }))
      this.$api.warehouseApi.fromStockPreview({ list }).then(res => {
        const previewList = this.getPreviewList(res.data)
        this.list = this.selectList.map((item, index) => {
          const previewItem = previewList[index] || previewList.find(preview => this.getStockId(preview) == item.id) || {}
          const canMoveNum = this.getCanMoveNum(Object.assign({}, item, previewItem))
          const defaultPackNum = Number(previewItem.num || previewItem.pack_num || canMoveNum || 1)
          return Object.assign({}, item, previewItem, {
            stock_id: this.getStockId(previewItem) || item.id,
            source_stock: item,
            can_move_num: canMoveNum,
            pack_num: canMoveNum > 0 ? Math.min(defaultPackNum, canMoveNum) : '',
          })
        })
      }).finally(() => {
        this.loading = false
      })
    },
    // 兼容接口返回数组、data.list、data.data 三种结构
    getPreviewList(data) {
      if (Array.isArray(data)) return data
      if (data && Array.isArray(data.list)) return data.list
      if (data && Array.isArray(data.data)) return data.data
      return []
    },
    // 获取库存原始行，预览数据会保留 source_stock 引用
    getSourceRow(row) {
      return row.source_stock || row
    },
    // 获取库存 ID，优先 stock_id
    getStockId(row) {
      return row.stock_id || row.id
    },
    // 获取采购单信息 order_purchase
    getOrderPurchase(row) {
      const source = this.getSourceRow(row)
      return row.order_purchase || source.order_purchase || {}
    },
    // 获取番号明细 order_detail
    getOrderDetail(row) {
      const orderPurchase = this.getOrderPurchase(row)
      return row.order_detail || orderPurchase.order_detail || {}
    },
    // 获取订单信息 order
    getOrder(row) {
      const orderPurchase = this.getOrderPurchase(row)
      return row.order || orderPurchase.order || {}
    },
    // 获取库位号，全角空格转半角后按空格拆分展示
    getGridNumber(row) {
      const source = this.getSourceRow(row)
      return String(row.grid_number || source.grid_number || '').replace('　', ' ')
    },
    // 获取订单号 order_sn
    getOrderSn(row) {
      const orderPurchase = this.getOrderPurchase(row)
      return row.order_sn || orderPurchase.order_sn || ''
    },
    // 获取客户姓名 order.user.realname
    getUserName(row) {
      const order = this.getOrder(row)
      return row.user_name || (order.user && order.user.realname) || ''
    },
    // 获取番号 sorting
    getSorting(row) {
      const orderDetail = this.getOrderDetail(row)
      return row.sorting || orderDetail.sorting || ''
    },
    // 获取商品图片 pic
    getPic(row) {
      const orderDetail = this.getOrderDetail(row)
      return row.pic || orderDetail.pic || ''
    },
    // 获取商品属性 detail_y
    getDetail(row) {
      const orderDetail = this.getOrderDetail(row)
      return row.detail_y || orderDetail.detail_y || []
    },
    // 获取交易号 purchase_no
    getPurchaseNo(row) {
      const orderPurchase = this.getOrderPurchase(row)
      return row.purchase_no || orderPurchase.purchase_no || ''
    },
    // 获取物流号列表 order_purchase_express
    getExpressList(row) {
      const orderPurchase = this.getOrderPurchase(row)
      return row.order_purchase_express || orderPurchase.order_purchase_express || []
    },
    // 获取可移库数，优先 can_move_num，否则取 num
    getCanMoveNum(row) {
      if (row.can_move_num !== undefined && row.can_move_num !== null && row.can_move_num !== '') {
        return Number(row.can_move_num)
      }
      return Number(row.num || 0)
    },
    // 限制直接装箱数量：只能填写正整数，并且不能大于可移库数
    limitNum(row) {
      const max = this.getCanMoveNum(row)
      const value = this.normalizePositiveInteger(row.pack_num)

      if (max < 1) {
        row.pack_num = ''
        this.$message.error('当前商品没有可移库数，无法直接装箱')
        return
      }
      if (!value) {
        row.pack_num = ''
        return
      }
      if (value > max) {
        row.pack_num = max
        this.$message.error('直接装箱数量不能大于可移库数')
        return
      }
      row.pack_num = value
    },
    // 将输入规整为正整数；非法字符会被剔除，0 会被修正为 1
    normalizePositiveInteger(value) {
      const text = String(value == null ? '' : value).replace(/[^\d]/g, '')
      if (!text) return ''
      const num = parseInt(text, 10)
      return num < 1 ? 1 : num
    },
    // 提交前兜底校验，防止空值、小数、负数或超过可移库数被提交
    isValidPackNum(item) {
      const packNum = Number(item.pack_num)
      const max = this.getCanMoveNum(item)
      return Number.isInteger(packNum) && packNum >= 1 && packNum <= max
    },
    // 切换箱型时同步长宽高
    changeAttr(value) {
      const size = this.getAttrSize(value)
      this.datas.c = size[0]
      this.datas.k = size[1]
      this.datas.g = size[2]
    },
    // 提交直接装箱：先校验数量和箱规重量，再打开普通仓库库位选择
    submit() {
      if (this.list.length == 0) {
        return this.$message.error('请选择商品后再进行操作')
      }
      const invalidItem = this.list.find(item => !this.isValidPackNum(item))
      if (invalidItem) {
        return this.$message.error('直接装箱数量只能填写正整数，并且不能大于可移库数')
      }
      if (!this.datas.c || !this.datas.k || !this.datas.g || !this.datas.weight) {
        return this.$message.error('请填写长宽高重量')
      }
      this.datas.grid_number = ''
      this.warehouseDialogVisible = true
    },
    // 仓库组件选择普通仓库库位后继续提交，datas.grid_number 由仓库组件写入
    submitPacking() {
      if (!this.datas.grid_number) {
        return this.$message.error('请选择普通仓库库位')
      }
      const datas = {
        list: this.list.map(item => ({
          stock_id: Number(this.getStockId(item)),
          num: Number(item.pack_num),
        })),
        attr: this.datas.attr,
        c: Number(this.datas.c),
        k: Number(this.datas.k),
        g: Number(this.datas.g),
        weight: Number(this.datas.weight),
        grid_number: this.datas.grid_number,
      }
      this.submitLoading = true
      this.$api.warehouseApi.packFromStock(datas).then(res => {
        this.$message.success(res.msg)
        this.dialogVisible = false
        this.$emit('success')
      }).finally(() => {
        this.submitLoading = false
      })
    },
  },
}
</script>

<style lang="scss" scoped>
/* 箱规表单：表头灰底 + 输入区白底 */
.direct-packing-form {
  margin-top: 28px;
  display: inline-block;
  border-top: 1px solid #EBEEF5;
  border-left: 1px solid #EBEEF5;

  /deep/.el-form {
    display: flex;
  }

  /deep/.el-form-item {
    width: 120px;
    margin-right: 0;
    margin-bottom: 0;
    border-right: 1px solid #EBEEF5;
    border-bottom: 1px solid #EBEEF5;
  }

  /deep/.el-input,
  /deep/.el-select {
    width: 100%;
  }

  /deep/.el-form-item__label {
    width: 100%;
    height: 40px;
    padding: 0;
    line-height: 40px;
    text-align: center;
    background-color: #EDEFF4;
    border-bottom: 1px solid #EBEEF5;
  }

  /deep/.el-form-item__content {
    height: 40px;
    line-height: 40px;
    padding: 4px 6px;
    background-color: #fff;
  }

  /deep/.el-input__inner {

    border-radius: 3px;
    background-color: #FAFCFF;
    text-align: center;
    color: #303133;
    font-weight: 500;
  }



  /deep/.el-input.is-focus .el-input__inner,
  /deep/.el-input__inner:focus {

    background-color: #fff;

  }

  /deep/.el-select .el-input__suffix {
    right: 4px;
  }

  /deep/.el-form-item:last-child {
    width: 150px;
  }
}

/* 直接装箱弹窗内容区与数量输入宽度 */
.direct-packing-dialog {
  /deep/.el-dialog__body {
    padding: 20px 32px;
  }

  /deep/.el-input-number--mini {
    width: 110px;
  }
}
</style>
